import script from "./LabelColissimo.vue?vue&type=script&setup=true&lang=ts"
export * from "./LabelColissimo.vue?vue&type=script&setup=true&lang=ts"

import "./LabelColissimo.vue?vue&type=style&index=0&id=3535101c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3535101c"]])

export default __exports__